"use client";

import { FormatListBulleted } from "@mui/icons-material";
import { Box, Button, ButtonGroup, Typography } from "@mui/material";
import { BulletList, ListItem } from "@tiptap/extension-list";
import Paragraph from "@tiptap/extension-paragraph";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

// editorContent is json
const TiptapContent = ({ editorContent, onChange, disabled }) => {
  console.log("editorContent", editorContent);
  const editor = useEditor({
    // extensions: [StarterKit],
    extensions: [StarterKit, BulletList, ListItem],
    content: editorContent ?? "",
    // Don't render immediately on the server to avoid SSR issues
    immediatelyRender: false,
    onUpdate({ editor }) {
      // The content has changed.

      let htmlValue = editor.getHTML();
      let jsonValue = editor.getJSON();
      let textValue = editor.getText();
      // console.log("Tiptap onUpdate", htmlValue, jsonValue, textValue);
      onChange(htmlValue, jsonValue, textValue);
    },
  });

  if (!editor) {
    return null;
  }
  return (
    <Box sx={{ flex: 1, width: "100%" }}>
      {!disabled && (
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "flex-end",
          }}
        >
          <ButtonGroup>
            <Button
              variant="outlined"
              onClick={() => editor.chain().focus().toggleBulletList().run()}
              className={editor.isActive("bulletList") ? "is-active" : ""}
            >
              <FormatListBulleted />
            </Button>
          </ButtonGroup>
        </Box>
      )}

      <Box sx={{ border: 1 }}>
        <EditorContent editor={editor} />
      </Box>
    </Box>
  );
};

const Tiptap = ({ editorContent, onChange, disabled }) => {
  if (editorContent !== undefined)
    return (
      <TiptapContent
        editorContent={editorContent}
        onChange={onChange}
        disabled={disabled}
      />
    );
};

export default Tiptap;
